// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1c4fa","container":"_1d68a","row":"b71ea","content":"_44218"};